//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Ship',
  props: {
    poTrackingDeliveryVo: {
      type: Object,
      required: true,
      default: null
    }
  },
  data: function data() {
    return {};
  }
};